/* eslint no-param-reassign: 0 */
import { getFilters } from 'client/api/v2/apiUtils';
import { parallelLimit } from 'async';
import CollectionApi from 'client/api/v2/CollectionApi';
import PolicyApi from 'client/api/v2/PolicyApi';
import SystemApi from 'client/api/v2/SystemApi';

export class SystemPolicyStatusApiClass extends CollectionApi {
  constructor(systemId = '') {
    super(`/api/v2/systems/${systemId}/policystatuses`, {
      skip: 0,
      limit: 50,
      filter: [
        {
          name: 'state',
          operator: 'ne',
          value: 'UNINSTALL_SUCCESS',
        },
      ],
    });
    this.systemId = systemId;
  }

  setSystemId(systemId = '') {
    this.baseUrl = `/api/v2/systems/${systemId}/policystatuses`;
    this.systemId = systemId;
  }

  fetch(skip, limit, sort, searchTerm, cancelToken, fltrs = []) {
    const filters = getFilters(fltrs, this.defaultParams.filter);
    return new Promise((resolve, reject) => {
      const tasks = [];
      const invalidResults = [];
      SystemApi.getBoundPolicies(this.systemId).then(boundPolicies => {
        super
          .fetch(skip, limit, sort, searchTerm, cancelToken, filters)
          .then((response) => {
            response.results.forEach((result) => {
              const exists = boundPolicies.results
                .some((boundPolicy) => boundPolicy.id === result.policyID);
              if (!exists && result.stdErr.includes('Duplicate')) {
                invalidResults.push(result.id);
              } else {
                tasks.push((cb) => {
                  PolicyApi
                    .get(result.policyID, cancelToken)
                    .then((policy) => {
                      result.policy = policy;
                      cb();
                    })
                    .catch((error) => {
                      reject(error);
                    });
                });
              }
            });
            parallelLimit(tasks, 5, (error) => {
              if (error) {
                reject(error);
              } else {
                const { results, totalCount } = response;
                // filters invalid policy results out of the list
                const filteredResults = results
                  .filter(result => !invalidResults
                    .some(invalid => invalid === result.id));
                const filteredTotalCount = totalCount - invalidResults.length;

                resolve({ results: filteredResults, totalCount: filteredTotalCount });
              }
            });
          })
          .catch((err) => {
            reject(err);
          });
      });
    });
  }

  /**
   * Override method from base class to append default filters to URL when getting items count so
   * that successfully uninstalled policies are not returned in the total count.
   */
  fetchTotalCount(customFilters = []) {
    const filters = this.setFilterTerm(null, getFilters(customFilters, this.defaultParams.filter));
    return super.fetchTotalCount(`${this.baseUrl}?filter=${filters}`);
  }

  async getSystemBoundPolicies() {
    return SystemApi.getBoundPolicies(this.systemId);
  }
}

export default new SystemPolicyStatusApiClass();
